<template>
    <div class="status-dialogs-order-review">
        <div class="status-dialogs-order-review__slogan">
            {{ getStatus(order) }}
        </div>
        <div class="status-dialogs-order-review__rate__title">
            Оцените работу нашей команды
        </div>
        <div class="status-dialogs-order-review__rate">
            <button
                v-for="index in 5"
                :key="index"
                @click.stop="updateRating(index)"
            >
                <img src="static/statuses-new/review/star_active.svg" v-if="order.rating >= index" />
                <img src="static/statuses-new/review/star.svg" v-else />
            </button>
        </div>
        <div class="status-dialogs-order-review__likes-block">
            <div class="status-dialogs-order-review__likes-block__line">
                <div class="status-dialogs-order-review__likes-block__value">
                    <div class="status-dialogs-order-review__likes-block__value__icon">
                        <img v-if="getEntityImg()" :src="getEntityImg()" />
                    </div>
                    {{ getEntity() }}
                </div>
                <div class="status-dialogs-order-review__likes-block__likes">
                    <div @click="entity_like = true" class="status-dialogs-order-review__likes-block__likes__item">
                        <img src="static/statuses-new/review/like_active.svg" v-if="entity_like === true" />
                        <img src="static/statuses-new/review/like.svg" v-else />
                    </div>
                    <div @click="entity_like = false" class="status-dialogs-order-review__likes-block__likes__item">
                        <img src="static/statuses-new/review/dislike_active.svg" v-if="entity_like === false" />
                        <img src="static/statuses-new/review/dislike.svg" v-else />
                    </div>
                </div>
            </div>
            <div class="status-dialogs-order-review__likes-block__line">
                <div class="status-dialogs-order-review__likes-block__value">
                    <div class="status-dialogs-order-review__likes-block__value__icon">
                        <img src="static/statuses-new/review/delivery.svg" />
                    </div>
                    Понравилась доставка?
                </div>
                <div class="status-dialogs-order-review__likes-block__likes">
                    <div @click="delivery_like = true" class="status-dialogs-order-review__likes-block__likes__item">
                        <img src="static/statuses-new/review/like_active.svg" v-if="delivery_like === true" />
                        <img src="static/statuses-new/review/like.svg" v-else />
                    </div>
                    <div @click="delivery_like = false" class="status-dialogs-order-review__likes-block__likes__item">
                        <img src="static/statuses-new/review/dislike_active.svg" v-if="delivery_like === false" />
                        <img src="static/statuses-new/review/dislike.svg" v-else />
                    </div>
                </div>
            </div>
        </div>

        <div class="status-dialogs-order-review__comments">

        </div>
        <div class="status-dialogs-order-review__comments">
            <div class="status-dialogs-order-review__comments__textarea">
                <textarea
                    name="message"
                    :value="comments"
                    @input="comments = $event.target.value"
                    placeholder="Мы будем очень благодарны, если вы оставите отзыв"
                    maxlength="210"
                ></textarea>
            </div>
            <div class="status-dialogs-order-review__comments__counter">
                {{ comments.length }} из 210
            </div>
        </div>
        
        <div class="status-dialogs-order-review__tips-block">
            <button
                class="status-dialogs-order-review__tips-button"
                @click="leaveTips">
                <img src="static/statuses-new/review/tips.svg" />
                <span>Оставить чаевые</span>
            </button>
        </div>

        <div>
            <button
                class="status-dialogs-order-review__submit-button"
                @click="submitReview">
                <span>Готово</span>
            </button>
        </div>
    </div>
</template>


<script>
    import moment from '../../plugins/moment';
    import store from '../../store';
    import { mapState } from 'vuex';
    import { DELIVERY_TYPE, DELIVERY_TYPE_TITLE, ORDER_STATUS, ORDER_PAYMENT_STATUS, PAYMENT_TYPE } from '@/js/utils/vars';
    import { goToExternalLink, sendAppMetricaEvent } from '../../js/utils/service-helpers';

    export default {
        name: 'StatusDialogOrderCard',

        props: {
            order: {
                type: Object,
                default: {},
            },
        },
        
        data: () => ({
            ORDER_STATUS,
            DELIVERY_TYPE_TITLE,
            shown: false,
            intervalId: null,
            freeSeconds: 195 * 60,
            paidWaitingFree: true,
            paidWaitingTimer: '',
            rating: 4,
            entity_like: null,
            delivery_like: null,
            comments: '',
            tipsId: process.env.VUE_APP_NETMONET_TIPS_DEFAULT_ID
        }),

        computed: {
            ...mapState('auth', {
                user: state => state.user
            }),
            ...mapState('info', ['towers']),

            delivery_address() {
                return this.order.id
                    ? (this.order.address
                        ? this.order.tower
                            ? this.towers.filter(tower => {
                                return tower.id === this.order.tower;
                            })[0].name
                            : this.order.address.street +
                                ' дом ' +
                                this.order.address.building
                        : '') +
                        (this.order.delivery_type !== DELIVERY_TYPE.MEETING_POINT
                            ? this.order.address_details
                                ? `, под/корп ${this.order.address_details.entrance}, этаж ${this.order.address_details.floor}, кв/оф ${this.order.address_details.appartment}`
                                : ''
                            : ', точка встречи')
                    : '';
            },
        },

        created() {
            this.startTimer();
        },
        destroyed() {
            clearInterval(this.intervalId);
        },

        methods: {
            startTimer() {
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
                this.paidWaitingFetch();
                this.intervalId = setInterval(() => {
                    this.paidWaitingFetch();
                }, 1000);
            },
            paidWaitingFetch() {
                if (this.order.status === ORDER_STATUS.MEETING_POINT) {
                    if (this.order.status === ORDER_STATUS.MEETING_POINT) {
                        const currentTime = moment().unix();
                        const updatedTime = moment(this.order.meeting_point_at).unix();
                        this.paidWaitingFree = currentTime - updatedTime < this.order.waiting_free_seconds;
                        let ms = (currentTime - updatedTime) - this.order.waiting_free_seconds;
                        if (this.paidWaitingFree) {
                            ms = this.order.waiting_free_seconds - (currentTime - updatedTime);
                        }
                        if(Math.floor(ms / 60) > 10) {
                            this.paidWaitingTimer = `${Math.floor(ms / 60)}:${('0' + ms % 60).slice(-2)}`;
                        } else {
                            this.paidWaitingTimer = `${('0' + Math.floor(ms / 60)).slice(-2)}:${('0' + ms % 60).slice(-2)}`;
                        }
                    }
                }
            },

            isPostpayment(order) {
                return order?.partner?.payment === PAYMENT_TYPE.POST_PAYMENT;
            },
            processingPayment(order) {
                return order && order.payments ? order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.PROCESSING) : false
            },
            faildPayment(order) {
                return order && order.payments ? order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.FAIL || item.status === ORDER_PAYMENT_STATUS.CANCELED) : false
            },
            getStatus(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                case ORDER_STATUS.PREPARED:
                    if(!this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'Платеж в обработке';
                        }
                        if(this.faildPayment(order)) {
                            return 'Оплата не прошла';
                        }
                        return 'Заказ не оплачен';
                    }
                case ORDER_STATUS.PAID:
                case ORDER_STATUS.ACCEPTED:
                    return 'Ваш заказ получен';
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.AWAITING:
                    return 'Заказ в работе';
                case ORDER_STATUS.AWAITING_READY:
                    return 'Заказ готов, курьер в пути';
                case ORDER_STATUS.DELIVERY:
                    return 'Заказ у курьера';
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    return 'Заказ у консьержа!';
                case ORDER_STATUS.MEETING_POINT:
                    return 'Заказ доставлен!';
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return 'Заказ выполнен!';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return 'Заказ отменен!';
                default:
                    return '';
                }
            },
            getEntity() {
                return this.order.rd?.items[0]?.restaurant.title
                    || this.order.gd?.items[0]?.grocer.title
                    || this.order.ed?.items[0]?.entity.title;
            },
            getEntityImg() {
                const entity = this.order.rd?.items[0]?.restaurant
                    || this.order.gd?.items[0]?.grocer
                    || this.order.ed?.items[0]?.entity;

                return entity?.square_picture && entity.square_picture !== ''
                    ? `${process.env.VUE_APP_IMAGES_URL}/thumb/${entity.square_picture}` 
                    : (entity?.picture ? `${process.env.VUE_APP_IMAGES_URL}/thumb/${entity.picture}` : '');
            },
            updateRating(rating) {
                sendAppMetricaEvent('review_stars_selected', {
                    stars_amount: rating
                });
                this.order.rating = rating === this.order.rating ? 0 : rating;
            },
            leaveTips() {
                if (this.order.concierge && this.order.concierge.tips_layout_id_new) {
                    this.tipsId = this.order.concierge.tips_layout_id_new;
                }
                goToExternalLink(`${ process.env.VUE_APP_NETMONET_TIPS_URL }/${ this.tipsId }`);
            },
            async submitReview() {
                this.$emit('submit-review');
                const review = {
                    order_id: this.order.id,
                    rating: this.order.rating,
                    entity_like: this.entity_like,
                    delivery_like: this.delivery_like,
                    text: this.comments,
                    finished: true,
                }
                await store.dispatch('orders/sendReview', { review });
                if(this.entity_like !== null || this.delivery_like !== null || this.comments.length) {
                    sendAppMetricaEvent('extended_review_sent', {
                        partner_review: this.entity_like === true ? 1 : 0,
                        delivery_review: this.delivery_like === true ? 1 : 0,
                        review_text: this.comments
                    });
                }
            }
        }
    };
</script>

<style lang="scss">
.status-dialogs-order-review {
    padding: 2px 8px;

    &__separate {
        height: 1px;
        background-color: #F4F4F4;
        margin: 12px 0 16px 0;
    }

    &__slogan {
        font-weight: 600;
        font-size: 22px;
        line-height: 100%;
        text-align: center;
        color: #232321;
    }
    &__rate {
        flex: 1 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        max-width: 277px;
        margin: 0 auto;

        &__title {
            font-weight: 400;
            font-size: 13px;
            line-height: 100%;
            text-align: center;
            color: #7D7D7D;
            margin-top: 16px;
            margin-bottom: 20px;
        }

        button {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }


    &__tips-block {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
    }
    &__tips-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        height: 40px;
        padding: 0 16px 0 12px;
        border-radius: 43px;
        background: #F4F4F4;
        font-weight: 500;
        font-size: 14px;
        line-height: 120%;
        text-align: center;
        color: #232321;

        img {
            margin-right: 10px;
        }
    }

    &__submit-button {
        width: 100%;
        height: 44px;
        border-radius: 90px;
        background: #1F3A60;
        font-weight: 500;
        font-size: 14px;
        line-height: 120%;
        text-align: center;
        color: #fff;
        margin-top: 32px;
    }

    &__likes-block {
        border-radius: 12px;
        background: #F4F4F4;
        padding: 0 8px 12px 8px;
        margin-top: 24px;

        &__line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 8px 0;
            margin-top: 12px;

            &:first-child {
                margin-top: 0;
            }
        }

        &__value {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            &__icon {
                width: 44px;
                height: 44px;
                border-radius: 8px;
                background: #FFFFFF;
                margin-right: 12px;
                overflow: hidden;
            }
        }
        &__likes {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            &__item {
                margin-left: 8px;

                &:first-child {
                    margin-left: 0;
                }
            }
        }
    }

    &__comments {
        margin-top: 12px;

        &__textarea {
            background: #ffffff;
            border: 1px solid #9599A4;
            border-radius: 16px;
            padding: 16px;
            margin-bottom: 8px;

            textarea {
                position: relative;
                width: 100%;
                min-height: 74px;
                font-weight: 400;
                font-size: 12px;
                line-height: 120%;
                color: #232321;
                z-index: 200;
            }
        }

        &__counter {
            font-family: Roboto;
            font-weight: 400;
            font-style: Regular;
            font-size: 12px;
            leading-trim: NONE;
            line-height: 16px;
            letter-spacing: 0.08px;
            color: #72808D;
        }
    }
}
</style>
